import { Container, Text, Flex, Heading } from "@chakra-ui/react";

const Skills = () => {
  return (
    <>
      <Container maxW="lg" mx="auto" px={4} py={4} marginTop="5rem">
        <Heading
          as="h1"
          size="4xl"
          textAlign="center"
          marginBottom="10rem"
          fontFamily={`'Rajdhani', sans-serif`}
          fontWeight={500}
        >
          My Tech Skills
        </Heading>
        <Flex direction="row" justify="center" alignItems="center" gap="80px">
          <i
            class="devicon-angularjs-plain  "
            style={{ fontSize: "100px" }}
          ></i>

          <i class="devicon-django-plain" style={{ fontSize: "100px" }}></i>

          <i class="devicon-graphql-plain " style={{ fontSize: "100px" }}></i>

          <i class="devicon-postgresql-plain" style={{ fontSize: "100px" }}></i>

          <i class="devicon-mongodb-plain" style={{ fontSize: "100px" }}></i>

          <i class="devicon-laravel-plain " style={{ fontSize: "100px" }}></i>
          <i class="devicon-nodejs-plain " style={{ fontSize: "100px" }}></i>

          <i class="devicon-react-original " style={{ fontSize: "100px" }}></i>

          <i
            class="devicon-selenium-original"
            style={{ fontSize: "100px" }}
          ></i>
        </Flex>
      </Container>
    </>
  );
};

export default Skills;
